import { Icon } from '@hapvida/hapvida-core-components';

import type { IAppRoute } from 'routes/types';

import { CompanyListRouter } from './pages/CompanyList/router';
import { ResponsibilityLetterRouter } from './pages/ResponsibilityLetter/router';

export const CompanyGroupRouter: IAppRoute = {
  Page: CompanyListRouter.Page,
  path: CompanyListRouter.path,
  name: 'Empresas',
  isPrivate: true,
  Icon: <Icon name="maps-b2b-home-work" />,
  subRoutes: [CompanyListRouter, ResponsibilityLetterRouter],
};
